export default {
    "type": "object",
    "required": [ 'orcode', 'ordesc' ],
    "properties": {
        "orcode": {
            "type": "string",
            "default": "",
            "title": "Region Code",
            "x-cols": "2",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 3
            },
        },
        "ordesc": {
            "type": "string",
            "default": "",
            "title": "Region Description",
            "x-cols": "10",
            "x-class": "pr-2",
            "x-props": {
                "readonly": false,
                "maxlength": 255
            },
        },
    }
}
